module.exports = __webpack_public_path__ + "img/icon-online-shop.224e8be5.svg";